export function saveDojoPreference(
  key: string,
  value: string | number | boolean | null | [] | object
) {
  window.preferencesService.savePreferenceByName(key, value, true);
}
